import React from 'react';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import './css/NoPage.css';

const NotFound = () => {
  return (
    <>
    <Navbar/>
    <div className="notfound-container">
      <h1 className="notfound-title">404</h1>
      <p className="notfound-message">Oops! The page you're looking for doesn't exist.</p>
      <a href="/" className="notfound-home-link">Go Back Home</a>
    </div>
    <Footer/>
    </>
  );
};

export default NotFound;
